import { memo, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import classNames from 'classnames';

import { getPageName } from '../../../../utils/widgets/shareWidget';
import { Button } from '../../../core/';
import { CodeForWidgetButton } from '../../../../utils/widgets/CodeForWidgetButton';
import { SvgIcon } from '../../../core/SvgIcon/SvgIcon';

import useStyles from './styles';
import { IEmbedModal } from './types';

function EmbedModal({ toolName, toolUrl, analytics, setShowShareModal, widgetUrl }: IEmbedModal) {
  const [codeCopied, setCodeCopied] = useState(false);
  const classes = useStyles({ buttonGreen: codeCopied, hasWidgetUrl: Boolean(widgetUrl) });

  const staticHtmlWidgetCode = renderToStaticMarkup(
    <MemoizedWidgetCode widgetUrl={widgetUrl} toolName={toolName} toolUrl={toolUrl} />,
  );

  const handleOnClick = () => {
    const pageName = getPageName();
    analytics.sharePage('copy_code', pageName);
    navigator.clipboard.writeText(staticHtmlWidgetCode);
    setCodeCopied(true);
  };

  return (
    <>
      <SvgIcon
        className={classes.svgIcon}
        name="arrow-carrousel-left-gen"
        onClick={() => setShowShareModal(true)}
      ></SvgIcon>
      <span className={classes.title}>Embed</span>
      <span className={classes.text}>Preview {toolName} Widget</span>
      <div className={classes.previewButtonContainer}>
        <div className={classNames({ [`${classes.widgetCodeHolder}`]: widgetUrl })}>
          <MemoizedWidgetCode widgetUrl={widgetUrl} toolName={toolName} toolUrl={toolUrl} />
        </div>
      </div>
      <span className={classes.text}>Code snippet {toolName} Widget</span>
      <div className={classes.codeContainer}>
        <span className={classes.widgetCode}>{staticHtmlWidgetCode}</span>
        <Button onClick={handleOnClick} className={classes.copyButton}>
          {codeCopied ? 'Code copied!' : 'Copy Code'}
        </Button>
      </div>
    </>
  );
}
export default EmbedModal;

const MemoizedWidgetCode = memo(function WidgetCode({
  widgetUrl,
  toolName,
  toolUrl,
}: {
  widgetUrl: string;
  toolName: string;
  toolUrl: string;
}) {
  if (widgetUrl) {
    return <iframe src={`${widgetUrl}`} frameBorder="0" height="100%" width="100%" />;
  }
  return <CodeForWidgetButton toolName={toolName} toolUrl={toolUrl} />;
});
